/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles((theme) => {
    const { typography } = theme;
    return {
        zodiacTopBanner: {
            '&.banner-container': {
                backgroundColor: '#F1F7F5',
                marginTop: '2rem',
                marginBottom: '2rem',
                padding: '3rem',
                textAlign: 'center',
                [theme.breakpoints.down('xs')]: {
                    marginTop: '1rem !important',
                    paddingTop: '1rem',
                    paddingBottom: '2.5rem',
                },
            },
            '&.astrologer-block': {
                backgroundColor: '#FFFFFF',
                borderRadius: '16px',
                boxShadow: '0px 3px 6px #00000029',
                padding: '1rem',
                marginLeft: '3rem',
                [theme.breakpoints.down('md')]: {
                    marginLeft: '0 !important',
                    marginRight: '0 !important',
                    paddingTop: '1.8rem',
                },
            },
            '&.plants-by-sign-block': {
                [theme.breakpoints.up('sm')]: {
                    paddingRight: '2rem',
                },
            },
            '&.in-the-stars': {},
            '&.sideLineWrapper': {
                marginBottom: '0.3rem',
                '&::before': {
                    content: '""',
                    borderBottom: '2px solid black',
                    position: 'absolute',
                    top: '13px',
                    left: '0',
                    width: '100%',
                },
            },
            '&.sideLine': {
                position: 'relative',
                zIndex: '2',
                paddingRight: '1rem',
                paddingLeft: '1rem',
                backgroundColor: '#F1F7F5',
                fontWeight: typography.fontWeightBold,
                fontSize: '1.5rem',
                letterSpacing: '1px',
            },
            '&.description': {
                fontSize: '1.110rem',
                marginTop: '1.4rem',
                [theme.breakpoints.up('lg')]: {
                    marginTop: '1.1rem',
                },
            },
            '&.description-banner': {
                marginTop: '1.4rem',
                fontSize: '1.07rem',
                [theme.breakpoints.up('md')]: {
                    marginTop: '3rem',
                    fontSize: '1.125rem',
                },
            },
            '&.description-banner-container': {
                [theme.breakpoints.down('md')]: {
                    paddingRight: '0',
                    paddingLeft: '0',
                },
            },
            '&.about-lisa': {
                margin: 'auto',
                paddingRight: '2rem',
                paddingLeft: '4rem',
                [theme.breakpoints.down('md')]: {
                    paddingLeft: '2rem',
                },
            },
            '&.about-name': {
                [theme.breakpoints.down('sm')]: {
                    marginTop: '0.8rem',
                    marginBottom: '0.3rem',
                },
            },
            '&.about-lisa-image': {
                [theme.breakpoints.up('lg')]: {
                    paddingRight: '0',
                },
            },
            '&.about-lisa-details': {
                paddingLeft: '0.1rem',
                paddingTop: '1.2rem',
                textAlign: 'left',
                [theme.breakpoints.down('md')]: {
                    textAlign: 'center',
                },
            },
            '&.name': {
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '& img': {
                    marginRight: 5,
                },
            },
            '& .position-relative': {
                position: 'relative',
            },
        },
    };
});

export default styles;
